import React, {useEffect, useState} from 'react';
import {withRouter} from '../common/with-router';
import {useDispatch, useSelector} from 'react-redux';
import Loading from '../components/global/loading';
import {ErrorMessage, Field, Form, Formik} from "formik";
import * as Yup from "yup";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSpinner} from '@fortawesome/free-solid-svg-icons';
import {toast} from 'react-toastify';
import {bioUpdate} from '../api/user';
import Modal from "../components/global/modal";
import {fieldRequestChange} from "../api/bio";

const Bio = (props) => {
	const dispatch = useDispatch();
	const currentUser = useSelector((state) => state.user);
	const [requestDetailsModal, setRequestDetailsModal] = useState(false);
	const [requestBirthdayModal, setRequestBirthdayModal] = useState(false);
	const [requestAppearanceModal, setRequestAppearanceModal] = useState(false);
	const [loading, setLoading] = useState(true);

	const getInitialData = () => {
		setLoading(false);
	}

	useEffect(() => {
		setLoading(true);
		getInitialData();
	}, []);

	const EditBioForm = () => {
		let initialValues = {
			hrr_number: '',
			first_name: '',
			initials: {
				0: '',
				1: '',
				2: '',
			},
			// last_name: '',
			dob: '',
			bio: '',
			coaching_history: '',
			coaching_ethos: '',
			coaching_additional_info: '',
			sporting_highlights: '',
			job_course_university: '',
			other_info: '',
		};

		if (currentUser && currentUser.user.role.includes('athlete')) {
			initialValues = {
				...initialValues,
				hrr_number: (currentUser && currentUser.user?.athlete?.hrr_number) ? currentUser.user?.athlete?.hrr_number : '',
				first_name: (currentUser && currentUser.user?.athlete?.first_name) ? currentUser.user?.athlete?.first_name : '',
				initials: {
					0: (currentUser && currentUser.user?.athlete?.initial_parts?.[0]) ? currentUser.user?.athlete?.initial_parts?.[0] : '',
					1: (currentUser && currentUser.user?.athlete?.initial_parts?.[1]) ? currentUser.user?.athlete?.initial_parts?.[1] : '',
					2: (currentUser && currentUser.user?.athlete?.initial_parts?.[2]) ? currentUser.user?.athlete?.initial_parts?.[2] : '',
				},
				last_name: (currentUser && currentUser.user?.athlete?.last_name) ? currentUser.user?.athlete?.last_name : '',
				dob: (currentUser && currentUser.user?.athlete?.dob) ? currentUser.user?.athlete?.dob : '',
				bio: (currentUser && currentUser.user?.athlete?.bio) ? currentUser.user.athlete?.bio : '',
				sporting_highlights: (currentUser && currentUser.user?.athlete?.sporting_highlights) ? currentUser.user.athlete.sporting_highlights : '',
				job_course_university: (currentUser && currentUser.user?.athlete?.job_course_university) ? currentUser.user.athlete.job_course_university : '',
				other_info: (currentUser && currentUser.user?.athlete?.other_info) ? currentUser.user.athlete.other_info : '',
			};
		}

		if (currentUser && currentUser.user.role.includes('coach')) {
			initialValues = {
				...initialValues,
				first_name: (currentUser && currentUser.user?.coach?.first_name) ? currentUser.user?.coach?.first_name : '',
				initials: {
					0: (currentUser && currentUser.user?.coach?.initial_parts?.[0]) ? currentUser.user?.coach?.initial_parts?.[0] : '',
					1: (currentUser && currentUser.user?.coach?.initial_parts?.[1]) ? currentUser.user?.coach?.initial_parts?.[1] : '',
					2: (currentUser && currentUser.user?.coach?.initial_parts?.[2]) ? currentUser.user?.coach?.initial_parts?.[2] : '',
				},
				last_name: (currentUser && currentUser.user?.coach?.last_name) ? currentUser.user?.coach?.last_name : '',
				bio: (currentUser && currentUser.user?.coach?.bio) ? currentUser.user.coach?.bio : '',
				coaching_history: (currentUser && currentUser.user?.coach?.coaching_history) ? currentUser.user.coach?.coaching_history : '',
				coaching_ethos: (currentUser && currentUser.user?.coach?.coaching_ethos) ? currentUser.user.coach?.coaching_ethos : '',
				coaching_additional_info: (currentUser && currentUser.user?.coach?.coaching_additional_info) ? currentUser.user.coach?.coaching_additional_info : '',
			};
		}

		const validationSchema = Yup.object().shape({
			// dob: Yup.string().required('Required'),
			bio: Yup.string().max(250, 'Bio must be 250 characters or fewer.'),
			sporting_highlights: Yup.string().max(280, 'Sporting Highlights must be 280 characters or fewer.'),
			job_course_university: Yup.string().max(120, 'Job/University must be 120 characters or fewer.'),
			other_info: Yup.string().max(280, 'Other must be 280 characters or fewer.'),
			initials: Yup.object().shape({
				0: Yup.string()
					.transform((value) => (value === '' ? undefined : value))
					.matches(/^[A-Z]-[A-Z]$|^[A-Z]$/i, 'format must be a single letter or two letters separated by a hyphen')
					.nullable(),
				1: Yup.string()
					.transform((value) => (value === '' ? undefined : value))
					.matches(/^[A-Z]-[A-Z]$|^[A-Z]$/i, 'format must be a single letter or two letters separated by a hyphen')
					.nullable(),
				2: Yup.string()
					.transform((value) => (value === '' ? undefined : value))
					.matches(/^[A-Z]-[A-Z]$|^[A-Z]$/i, 'format must be a single letter or two letters separated by a hyphen')
					.nullable(),
			}),
			coaching_history: Yup.string().max(250, 'Coaching history must be 250 characters or fewer.'),
			coaching_ethos: Yup.string().max(250, 'Coaching ethos should be 250 characters or less.'),
			coaching_additional_info: Yup.string().max(250, 'Additional info cannot exceed 250 characters.')
		});

		const onSubmit = async (values, { setSubmitting }) => {
			setSubmitting(true);
			const toastId = toast("Saving...", { autoClose: false });

			const data = {
				...values,
			};

			// if (props.router?.params?.id) {
			// 	data.id = props.router?.params?.id;
			// }

			try {
				const doProfileUpdate = await bioUpdate(currentUser.user.id, data);
				if (doProfileUpdate.data) {
					try {
						// const thiscurrentUser = await setCurrentUser(user);
						dispatch({ type: 'USER', payload: doProfileUpdate.data.user });
						toast.update(toastId, { type: toast.TYPE.SUCCESS, render: "Profile saved!", autoClose: 5000 });
					} catch (error) {
						toast.update(toastId, { type: toast.TYPE.ERROR, render: "Error saving profile.", autoClose: 5000 });
						console.log(error);
					}
				}
			} catch (error) {
				console.log(error);
			}
		};

		return (
			<div className="col-md-12">
				<div className="card card-container">
					<Formik
						initialValues={initialValues}
						validationSchema={validationSchema}
						onSubmit={onSubmit}
					>
						{({ values, setFieldValue, isValid, isSubmitting }) => {
							return (
								<Form>
									<div className="row">
										{(currentUser && currentUser.user.role.includes('athlete')) && 
											<div className="col-md-12">
												<div className="form-group-flex">
													<label htmlFor="currentUsername">HRR Number</label>
													<Field type="text" className="form-control" name="hrr_number" disabled />
													<ErrorMessage name="hrr_number" component="div" className="field-error" />
												</div>
											</div>
										}
										<div className="col-8 col-md-4">
											<div className="form-group-flex">
												<label htmlFor="currentUsername">First Name</label>
												<Field type="text" className="form-control" name="first_name" />
												<ErrorMessage name="first_name" component="div" className="field-error" />
											</div>
										</div>
										<div className="col col-md-4">
											<div className="form-group-flex">
												<label htmlFor="currentUsername">Initials</label>
												<div className="d-flex ms-n1">
													<div className="px-1">
														<Field type="text" className="form-control" name="initials[0]" />
														<ErrorMessage name="initials[0]" component="div" className="field-error" />
													</div>
													{(values.initials?.[0]?.length > 0) &&
														<div className="px-1">
															<Field type="text" className="form-control" name="initials[1]" />
															<ErrorMessage name="initials[1]" component="div" className="field-error" />
														</div>
													}
													{(values.initials?.[1]?.length > 0) &&
														<div className="px-1">
															<Field type="text" className="form-control" name="initials[2]" />
															<ErrorMessage name="initials[2]" component="div" className="field-error" />
														</div>
													}
												</div>
											</div>
										</div>
										<div className="col-md-4">
											<div className="form-group-flex">
												<label htmlFor="event_code">Last Name</label>
												<Field type="text" name="last_name" className="form-control" disabled={true} />
												<button onClick={() => setRequestDetailsModal(true)} className="btn btn-link">Change</button>
											</div>
										</div>
										{(currentUser && currentUser.user.role.includes('athlete')) && 
											<div className="col-md-6">
												<div className="form-group-flex">
													<label htmlFor="event_code">DOB (DD/MM/YYYY)</label>
													<Field type="text" name="dob" className="form-control" disabled />
													<ErrorMessage name="dob" component="div" className="field-error" />
													<button onClick={() => setRequestBirthdayModal(true)} className="btn btn-link">Please correct my date of birth</button>
												</div>
											</div>
										}
										<div className="col-12"></div>
										{(currentUser && currentUser.user.role.includes('athlete')) && 
											<div className="col-md-6">
												<div className="form-group-flex">
													<label htmlFor="currentUsername">HRR Appearances</label>
													<Field type="text" className="form-control" name="participations" value={currentUser.user?.athlete?.participations} disabled={true} />
													<button onClick={() => setRequestAppearanceModal(true)} className="btn btn-link">Please correct my appearance count or wins</button>
												</div>
											</div>
										}
									</div>

									<hr />

									{(currentUser && currentUser.user.role.includes('coach')) &&
										<>
											<h3>Coach Biography</h3>
											<p>Please complete the following fields and click the 'Save Bio' button.</p>

											<div className="form-group-flex">
												<label htmlFor="bio">Bio</label>
												<Field component="textarea" name="bio" className="form-control"/>
												<ErrorMessage name="bio" component="div" className="field-error" />
											</div>
											<div className="form-group-flex">
												<label htmlFor="coaching_history">Please share your coaching history, briefly</label>
												<Field component="textarea" name="coaching_history" className="form-control"/>
												<ErrorMessage name="coaching_history" component="div" className="field-error" />
											</div>
											<div className="form-group-flex">
												<label htmlFor="coaching_ethos">What is your coaching ethos?</label>
												<Field component="textarea" name="coaching_ethos" className="form-control"/>
												<ErrorMessage name="coaching_ethos" component="div" className="field-error" />
											</div>
											<div className="form-group-flex">
												<label htmlFor="coaching_additional_info">What else would you like to tell us, either about the crew or yourself?</label>
												<Field component="textarea" name="coaching_additional_info" className="form-control"/>
												<ErrorMessage name="coaching_additional_info" component="div" className="field-error" />
											</div>
										</>
									}

									<hr/>

									{(currentUser && currentUser.user.role.includes('athlete')) &&
										<>
											<h3>Athlete Biography</h3>
											<p>Please complete the following fields and click the 'Save Bio' button.</p>

											<div className="form-group-flex">
												<label htmlFor="event_code">Sporting Highlights</label>
												<Field component="textarea" name="sporting_highlights" className="form-control" />
												<ErrorMessage name="sporting_highlights" component="div" className="field-error" />
											</div>
											<div className="form-group-flex">
												<label htmlFor="event_code">Job/University</label>
												<Field component="textarea" name="job_course_university" className="form-control" />
												<ErrorMessage name="job_course_university" component="div" className="field-error" />
											</div>
											<div className="form-group-flex">
												<label htmlFor="event_code">Other</label>
												<Field component="textarea" name="other_info" className="form-control" />
												<ErrorMessage name="other_info" component="div" className="field-error" />
											</div>
										</>
									}

									<div className="form-group form-buttons mt-3">
										<button
											className="btn btn-primary btn-submit"
											type="submit"
											disabled={(isSubmitting)}
										>
											{isSubmitting && (
												<FontAwesomeIcon icon={faSpinner} spin />
											)}
											<span>Save Bio</span>
										</button>
									</div>
								</Form>
							)
						}}
					</Formik>
				</div>
			</div>
		);
	}

	const lastNameModal = () => {
		const initialValues = {
			requested_last_name: '',
		}

		const validationSchema = Yup.object().shape({
			requested_last_name: Yup.string().required('Required'),
		});

		const onSubmit = async (values, { setSubmitting }) => {
			const toastId = toast("Sending request...", { autoClose: false });

			setSubmitting(true);

			const data = {
				field_type: "last_name",
				requested_value: values.requested_last_name,
			};

			try {
				const dataChangeResponse = await fieldRequestChange(data);
				if (dataChangeResponse.data.status === 'success') {
					toast.update(toastId, { type: toast.TYPE.SUCCESS, render: "Request sent", autoClose: 5000 });
				}
			} catch (error) {
				toast.update(toastId, { type: toast.TYPE.ERROR, render: "Something went wrong, please try again later", autoClose: 5000 });
				console.log(error);
			}

			setSubmitting(false);
			setRequestDetailsModal(false);
		}

		return (
			<Formik
				initialValues={initialValues}
				validationSchema={validationSchema}
				onSubmit={onSubmit}
			>
				{({ values, setFieldValue, isValid }) => (
					<Form>
						<div>
							<p><b>Current last name:</b> {currentUser.user?.last_name}</p>
						</div>
						<label htmlFor="requested_last_name">Last name change</label>
						<Field type="text" className="form-control" name={`requested_last_name`} required placeholder="Enter last name....."/>
						<div className="modal-footer">
							<button type="button" className="btn btn-secondary" onClick={() => setRequestDetailsModal(false)}>
								Close
							</button>
							<button type="submit" className="btn btn-primary">
								Request Change
							</button>
						</div>
					</Form>
				)}
			</Formik>
		)
	}

	const birthdayModal = () => {
		const initialValues = {
			requested_dob: '',
		}

		const validationSchema = Yup.object().shape({
			requested_dob: Yup.date().required('Required'),
		});

		const onSubmit = async (values, { setSubmitting }) => {
			const toastId = toast("Sending request...", { autoClose: false });

			setSubmitting(true);

			const data = {
				field_type: "dob",
				requested_value: values.requested_dob,
			}

			try {
				const dobRequestChange = await fieldRequestChange(data);
				if (dobRequestChange.data.status === 'success') {
					toast.update(toastId, { type: toast.TYPE.SUCCESS, render: "Request sent", autoClose: 5000 });
				}
			} catch (error) {
				toast.update(toastId, {
					type: toast.TYPE.ERROR,
					render: "Something went wrong, please try again later",
					autoClose: 5000
				});
				console.log(error);
			}

			setSubmitting(false);
			setRequestBirthdayModal(false);
		}

		return (
			<Formik
				initialValues={initialValues}
				validationSchema={validationSchema}
				onSubmit={onSubmit}
			>
				{({ values, setFieldValue, isValid }) => (
					<Form>
						<div>
							<p><b>Current date of birth:</b> {currentUser.user?.athlete?.dob}</p>
						</div>
						<label htmlFor="requested_dob">Please enter your correct date of birth</label>
						<Field name="requested_dob" type="date" className="form-control" />
						<ErrorMessage name="requested_dob" />
						<div className="modal-footer">
							<button type="button" className="btn btn-secondary" onClick={() => setRequestBirthdayModal(false)}>
								Close
							</button>
							<button type="submit" className="btn btn-primary">
								Request Change
							</button>
						</div>
					</Form>
				)}
			</Formik>
		)
	}

	const appearancesModal = () => {
		const initialValues = {
			requested_appearances: '',
		}

		const validationSchema = Yup.object().shape({
			requested_appearances: Yup.date().required('Required'),
		});

		const onSubmit = async (values, { setSubmitting }) => {
			const toastId = toast("Sending request...", { autoClose: false });

			const data = {
				field_type: "appearances",
				requested_value: values.requested_appearances,
			}

			setSubmitting(true);

			try {
				const appearancesRequestChange = await fieldRequestChange(data);
				if (appearancesRequestChange.data.status === 'success') {
					toast.update(toastId, { type: toast.TYPE.SUCCESS, render: "Request sent", autoClose: 5000 });
				}
			} catch (error) {
				toast.update(toastId, {
					type: toast.TYPE.ERROR,
					render: "Something went wrong, please try again later",
					autoClose: 5000
				});
				console.log(error);
			}

			setSubmitting(false);
			setRequestAppearanceModal(false);
		}

		return (
			<Formik
				initialValues={initialValues}
				validationSchema={validationSchema}
				onSubmit={onSubmit}
			>
				{({ values, setFieldValue, isValid }) => (
					<Form>
						<div>
							<p><b>Current HRR Appearances:</b> {currentUser.user?.athlete?.participations}</p>
						</div>
						<label htmlFor="requested_appearances">Please enter the number of years you have raced at the Regatta (excluding qualifying races).</label>
						<Field name="requested_appearances" type="number" className="form-control" />
						<ErrorMessage name="requested_appearances" />
						<div className="modal-footer">
							<button type="button" className="btn btn-secondary" onClick={() => setRequestAppearanceModal(false)}>
								Close
							</button>
							<button type="submit" className="btn btn-primary">
								Request Change
							</button>
						</div>
					</Form>
				)}
			</Formik>
		)
	}

	if (loading) {
		return <Loading />;
	}

	return (
		<div className="container-fluid">
			<div className="row">
				<div className="col-12">
					{(currentUser) && <h1>Edit Bio</h1>}
				</div>

				<div className="col-12 form-group">
					{<EditBioForm />}
				</div>
			</div>
			<Modal
				title="Change Request"
				onSave={() => setRequestDetailsModal(false)}
				onClose={() => setRequestDetailsModal(false)}
				setShow={setRequestDetailsModal}
				show={requestDetailsModal}
				children={lastNameModal()}
			/>
			<Modal
				title="Please correct my date of birth"
				onSave={() => setRequestBirthdayModal(false)}
				onClose={() => setRequestBirthdayModal(false)}
				setShow={setRequestBirthdayModal}
				show={requestBirthdayModal}
				children={birthdayModal()}
			/>
			<Modal
				title="Please correct my appearance count or wins"
				onSave={() => setRequestAppearanceModal(false)}
				onClose={() => setRequestAppearanceModal(false)}
				setShow={setRequestAppearanceModal}
				show={requestAppearanceModal}
				children={appearancesModal()}
			/>
		</div>
	);
}

export default withRouter(Bio);
